import { motion } from 'framer-motion';
import ChampionshipCard from '../ChampionshipCard';
import { visionData } from '../../data/championshipData';
import { Box, Container, Typography } from '@mui/material';

function HistoryVision() {
    return (
        <Box
            sx={{
                bgcolor: '#181818', /* Netflix Gray - Modern balanced dark UI background */
                position: 'relative',
                overflow: 'hidden',
                py: { xs: 10, md: 10 }
            }}
        >
            <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}
                >
                    <Typography
                        variant="h2"
                        sx={{
                            mb: 4,
                            fontFamily: 'Bebas Neue',
                            color: 'white',
                            fontSize: { xs: '3rem', md: '4.5rem' },
                            letterSpacing: '2px',
                            position: 'relative',
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            '&::after': {
                                content: '""',
                                height: 4,
                                width: 80,
                                bgcolor: 'secondary.main',
                                borderRadius: '2px'
                            },
                        }}
                    >
                        Looking Ahead
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, textAlign: 'center', color: 'rgba(255,255,255,0.7)', fontSize: '1.1rem' }}>
                        The AAGC has proven itself as a unique, inclusive, and adaptable model of grassroots motorsport. With a shared vision, persistent effort, and genuine regional cooperation, we believe this model can be expanded to other regions and continents.
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.8, textAlign: 'center', color: 'rgba(255,255,255,0.7)', fontSize: '1.1rem' }}>
                        Our ultimate dream: a FIA Auto Gymkhana World Cup, akin to the FIFA World Cup—uniting drivers from around the world through skill, spirit, and sport.
                    </Typography>
                </motion.div>

                <Box sx={{
                    mt: 8,
                    width: '100%',
                    display: 'flex',
                    gap: { xs: 6, md: 6 },
                    justifyContent: 'center',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'center', md: 'stretch' },
                }}>
                    {visionData.map((data, index) => (
                        <Box
                            key={index}
                            sx={{ display: 'flex' }}
                            component={motion.div}
                            viewport={{ once: true }}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: index * 0.2 }}
                        >
                            <ChampionshipCard
                                year={data.year}
                                rounds={data.rounds}
                                subTitle={data.subTitle}
                                heroImage={data.heroImage}
                                statusLabel={data.statusLabel}
                            />
                        </Box>
                    ))}
                </Box>
            </Container>
            <Box sx={{ position: 'absolute', top: '-5%', left: '-5%', width: '30%', height: '40%', bgcolor: 'secondary.main', opacity: 0.15, filter: 'blur(120px)', borderRadius: '50%', zIndex: 1, pointerEvents: 'none', }} />
            <Box sx={{ position: 'absolute', bottom: '-5%', right: '-5%', width: '30%', height: '40%', bgcolor: 'secondary.main', opacity: 0.15, filter: 'blur(120px)', borderRadius: '50%', zIndex: 1, pointerEvents: 'none', }} />
        </Box>
    );
}

export default HistoryVision;
